import React from "react";
import BuyersPremiumReduction from "@/components/buyers-premium/BuyersPremiumReduction";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Hubzu | Buyers Premium Reduction",
};

const BuyersPremiumReductionScreen = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <BuyersPremiumReduction />
    </>
  );
};

export default BuyersPremiumReductionScreen;
